"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
class ErrorScreen extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.errorInfo) {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("h2", null, "Something went wrong."),
                react_1.default.createElement("details", { style: { whiteSpace: 'pre-wrap' } },
                    this.state.error && this.state.error.toString(),
                    react_1.default.createElement("br", null),
                    this.state.errorInfo.componentStack)));
        }
        return this.props.children;
    }
}
exports.ErrorScreen = ErrorScreen;
exports.default = ErrorScreen;
